import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ContentPath } from '../content-header/content-path';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.less'],
  standalone: false
})
export class AdminLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  navbarOk: boolean = false;
  contentOk: boolean = false;
  sidebarOk: boolean = false;
  footerOk: boolean = false;
  private resizeObserver?: ResizeObserver;
  private routerSubscription?: any;
  private readonly SIDEBAR_STATE_KEY = 'smo_sidebar_state';

  @Input()
  title: string = '';

  @Input()
  subtitle: string = '';

  @Input()
  contentsPath: ContentPath[] = [];

  @Input()
  contentId: string = '';

  @Input()
  showContentHeader: boolean = true;

  constructor(
    public authService: AuthService,
    public el: ElementRef,
    private router: Router
  ) { }

  onNavbarOk(): void {
    this.navbarOk = true;

    this.rebindEvents();
  }

  onSidebarOk(): void {
    this.sidebarOk = true;

    this.rebindEvents();
  }

  onFooterOk(): void {
    this.footerOk = true;

    this.rebindEvents();
  }

  ngOnInit() {
    // Recalculate the layout height after each navigation, since the active
    // sidebar menu (and therefore the sidebar height) changes per route.
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          ($('body') as any).layout('fix');
        }, 250);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    ($('body') as any).off('.adminLayout');
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    ($('body') as any).layout('fix');
  }

  ngAfterViewInit(): void {
    this.contentOk = true;

    this.rebindEvents();

    // Observe the sidebar for height changes. The AdminLTE layout computes
    // `.content-wrapper { min-height }` from the sidebar height, but only does so
    // on manual tree toggles. The sidebar grows asynchronously after load (saved
    // expanded state + routerLinkActive applying `menu-open` to the active treeview),
    // so we re-run the native `layout('fix')` whenever the sidebar resizes.
    const sidebar = this.el.nativeElement.querySelector('.main-sidebar');
    if (sidebar) {
      let raf = 0;
      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => ($('body') as any).layout('fix'));
      });
      this.resizeObserver.observe(sidebar);
    }
  }

  rebindEvents(): void {
    if (this.contentOk) {
      if (this.navbarOk && this.sidebarOk && this.footerOk) {
        this.navbarOk = false;
        this.sidebarOk = false;
        this.footerOk = false;

        /*
         * routerLinkActive ainda nao seto a classe ainda no ngAfterViewInit
         * por isso do settimeout.
         */
        setTimeout(() => {
          //console.log('Rebind Admin Layout Events');

          $('[data-widget="tree"]').each(function () {
            ($(this) as any).tree();
          });

          // Apply the saved sidebar collapse/expand state BEFORE the layout
          // measures the sidebar, so the first height calculation already uses
          // the final sidebar state.
          this.bindSidebarState();

          ($('body') as any).layout();
        }, 0);
      }
    }
  }

  private bindSidebarState(): void {
    const saved = localStorage.getItem(this.SIDEBAR_STATE_KEY);

    if (saved === 'expanded') {
      $('body').removeClass('sidebar-collapse');
    } else {
      // Default: sidebar colapsada
      $('body').addClass('sidebar-collapse');
    }

    // Remove listeners anteriores para evitar duplicatas
    ($('body') as any).off('expanded.pushMenu.adminLayout collapsed.pushMenu.adminLayout');

    ($('body') as any).on('expanded.pushMenu.adminLayout', () => {
      localStorage.setItem(this.SIDEBAR_STATE_KEY, 'expanded');
    });

    ($('body') as any).on('collapsed.pushMenu.adminLayout', () => {
      localStorage.setItem(this.SIDEBAR_STATE_KEY, 'collapsed');
    });
  }

}
